import router from "@/router";
import i18n from "../../i18n";
import axios from "axios";

export default {
  state: {
    qnaStatus: null,
    qnaKeyword: "",
    wrongAnswerCount: 0,
    court: "",
    isThinking: false,
    requestQna: true,
  },
  getters: {
    getQnaStatus: (state) => state.qnaStatus,
    getQnaKeyword: (state) => state.qnaKeyword,
    getWrongAnsCount: (state) => state.wrongAnswerCount,
    getCourt: (state) => state.court,
    getIsThinking: (state) => state.isThinking,
    getRequestQna: (state) => state.requestQna,
  },
  mutations: {
    setQnaStatus(state, status) {
      state.qnaStatus = status;
    },
    setQnaKeyword(state, keyword) {
      state.qnaKeyword = keyword;
    },
    setWrongAnswerCount(state, count) {
      state.wrongAnswerCount = count;
    },
    setCourt(state, court) {
      state.court = court;
    },
    setIsThinking(state, status) {
      state.isThinking = status;
    },
    setRequestQna(state, status) {
      state.requestQna = status;
    },
  },
  actions: {
    requestQnA({ getters, dispatch, commit }, transcript) {
      return new Promise((response, reject) => {
        if (getters.isThinking) {
          commit("setSpeechTranscript", transcript);
          commit("setTextBubbleText", transcript);
        }
        commit("setQnaStatus", "Thinking");

        let data = JSON.stringify({
          question: transcript,
          lang: "english",
          client: "nmkiosklc",
        });

        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://zjul4g7rfl.execute-api.us-east-1.amazonaws.com/stage/api/query",
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };
        commit("setIsThinking", true);
        axios.request(config).then((response) => {
          // Logging the questions asked to the AI
          const qnaAnalytics = {
            timeStamp: new Date(),
            kioskID: getters.getKioskId,
            transcript: transcript,
            result: response.data.answer,
          };
          //dispatch('sendQnaData', qnaAnalytics);
          dispatch("addQnaDatatoStrapi", qnaAnalytics);
          // Logging the kiosk utilization
          commit("setTouchRequest", {
            module: "QnA",
            action: transcript,
            response: response.data.answer,
            timeStamp: new Date(),
            requestType: "Speech",
          });
          dispatch("addInteractionToPostgres", {
            actionType: "Interaction",
            actionPayload: {
              module: "QnA",
              navigateFrom: "Home",
              navigateTo: "Home",
              interactionType: "Speech",
              elementContent: {
                question: transcript,
                answer: response.data.answer,
                confidenceScore: 1,
              },
            },
          });
          dispatch("generateAnswer", response.data);
        });
      });
    },
    generateAnswer({ dispatch, commit, getters }, result) {
      console.log("Response from AI: ", result);
      commit("setQnaStatus", false);
      const metadata = result.answer.intent.toString();
      const ansObj = result.answer;
      commit("setDefaultBubbleText", false);
      commit("setIsThinking", false);
      commit("closeOptionsViewer");
      switch (metadata) {
        case "1":
          var menuName = ansObj.metadata.path;
          router.addRoute({
            path: menuName.toLowerCase(),
            component: () => import("@/views/" + menuName),
          });
          if (router.currentRoute.path !== menuName) {
            router.push(menuName).then(() => {
              commit("setQnaKeyword", "");
              dispatch("avatarSpeak", ansObj.response);
              let page = i18n
                .t("homepages")
                .filter((page) => page.pageType[0].pathName === menuName);
              commit("setPageHeader", page[0].pageType[0].pageHeader);
            });
          } else {
            commit("setQnaKeyword", "");
            dispatch("avatarSpeak", ansObj.response);
          }
          break;

        case "3":
          try {
            var mapPath;
            let mapName = ansObj.metadata.mappath;
            i18n.t("maps").forEach((map) => {
              if (map.displayPosition.toString() === mapName.toString()) {
                mapPath = map;
              }
            });
            dispatch("openImageViewer", {
              name: mapPath.mapName,
              url: mapPath.mapImage,
            });
            dispatch("avatarSpeak", ansObj.response);
          } catch (e) {
            console.log(e.message);
            getters.getMaps.forEach((map) => {
              if (
                map.mapName.toLowerCase() ===
                getters.getDefaultLocation.toLowerCase()
              ) {
                dispatch("openImageViewer", {
                  name: map.mapName,
                  url: map.mapImage,
                });
              }
            });

            //dispatch('avatarSpeak', 'Sorry, I\'m not sure how to answer this question. Please ask me a different question, or you can continue using the touch interface. Also, you can get more information at the Clerk’s Office located here.')
            if (getters.getCurrentLanguage === "en-US") {
              dispatch(
                "avatarSpeak",
                "Sorry, I'm not sure how to answer this question. Please ask me a different question, or you can continue using the touch interface. Also, you can get more information at the location circled in red.",
              );
            } else {
              dispatch(
                "avatarSpeak",
                "Lo siento. No estoy seguro de cómo responder esta pregunta. Por favor, hazme una pregunta diferente, o puedes continuar usando la interfaz táctil. Además, puede obtener más información en la ubicación rodeada de rojo.",
              );
            }
          }
          break;

        case "4":
          dispatch("avatarSpeak", ansObj.response);
          break;

        case "6":
          try {
            var formName = ansObj.metadata.formname;
            i18n.t("forms").forEach((form) => {
              if (form.formNumber.toLowerCase() === formName) {
                dispatch("openPdfViewer", {
                  url: form.formPdf,
                  name: form.formName,
                  emailLink: form.pdfUrl,
                  type: "Form",
                });
                console.log("Coming here in if");
                dispatch("avatarSpeak", ansObj.response);
              } else {
                // Only english form available
                console.log("Coming here in else");
                getters.getForms.forEach((form) => {
                  if (form.formName.toLowerCase() === formName) {
                    dispatch("openPdfViewer", {
                      url: form.formPdf,
                      name: form.formName,
                      emailLink: form.pdfUrl,
                      type: "Form",
                    });
                    dispatch("avatarSpeak", ansObj.response);
                  }
                });
              }
            });
          } catch (e) {
            console.log(e.message);
            getters.getMaps.forEach((map) => {
              if (
                map.mapName.toLowerCase() ===
                getters.getDefaultLocation.toLowerCase()
              ) {
                dispatch("openImageViewer", {
                  name: map.mapName,
                  url: map.mapImage,
                });
              }
            });
            //dispatch('avatarSpeak', 'Sorry! I just started working here, I will soon know answers to all the court related questions. Pleas try asking different question or visit Clerk\'s office.');
            if (getters.getCurrentLanguage === "en-US") {
              dispatch(
                "avatarSpeak",
                "Sorry, I'm not sure how to answer this question. Please ask me a different question, or you can continue using the touch interface. Also, you can get more information at the location circled in red.",
              );
            } else {
              dispatch(
                "avatarSpeak",
                "Lo siento. No estoy seguro de cómo responder esta pregunta. Por favor, hazme una pregunta diferente, o puedes continuar usando la interfaz táctil. Además, puede obtener más información en la ubicación rodeada de rojo.",
              );
            }
          }
          break;

        case "2":
          commit("setQnaKeyword", "");
          var faqKeyword = ansObj.metadata.linkid;

          // For Navigation and setting the Page header
          router.addRoute({
            path: "/faqs",
            component: () => import("@/views/faqs"),
          });
          if (router.currentRoute.path !== "/faqs") {
            router.push("/faqs");
          }
          var page = i18n
            .t("homepages")
            .filter((page) => page.pageType[0].pathName === "faqs");
          commit("setPageHeader", page[0].pageType[0].pageHeader);
          //commit('setPageHeader', 'Frequently Asked Questions')

          // The below fetchs the keyword from QNA and checks if the keyword is a category or not.
          // If category, then search output is category
          // Else, search is done on keyword

          var count = i18n
            .t("faqCategory")
            .filter((cat) => cat.categoryName.toLowerCase() === faqKeyword);
          if (count.length === 0) {
            console.log("Faq Keyword search: ", faqKeyword);
            commit("setQnaKeyword", faqKeyword);
          } else {
            commit("setSelectedFaqCat", {
              name: faqKeyword,
              type: "expansionPanel",
            });
          }
          dispatch("avatarSpeak", ansObj.response);
          break;
        case "8":
          dispatch("avatarSpeak", ansObj.response);
          window.open(ansObj.metadata.link, "_blank");
          break;
        case "showformcategory":
          var formKeyword = ansObj.metadata.keyword;
          router.addRoute({
            path: "/forms",
            component: () => import("@/views/forms"),
          });
          if (router.currentRoute.path !== "/forms") {
            router.push("/forms");
          }
          page = i18n
            .t("homepages")
            .filter((page) => page.pageType[0].pathName === "forms");
          commit("setPageHeader", page[0].pageType[0].pageHeader);
          //commit('setPageHeader', 'Forms')
          commit("setSelectedFormCat", { category: formKeyword });
          dispatch("avatarSpeak", ansObj.answer);
          break;

        case "showformpackets":
          var packetInfo;
          packetInfo = getters.getFormPackets.filter(
            (pack) => pack.packetName.toLowerCase() === ansObj.metadata.keyword,
          );
          dispatch("openPdfViewer", {
            url: packetInfo[0].packetFiles,
            name: packetInfo[0].packetName,
            desc: packetInfo[0].packetDesc,
            emailLink: packetInfo[0].packetLink,
            type: "Packet",
          });
          dispatch("avatarSpeak", ansObj.answer);
          break;

        case "0":
          console.log("Followup questions: ", i18n.t("followup"))
          var prompts = i18n.t("followup").split(",");
          dispatch("avatarSpeak", ansObj.response);
          var headerVal;
          if (getters.getCurrentLanguage === "en-US") {
            headerVal =
              "Tap on the below, or click on the microphone to ask another question";
          } else {
            headerVal =
              "Pulse en el siguiente botón, o haga clic en el micrófono para hacer otra pregunta";
          }
          dispatch("openOptionsViewer", {
            dialogHeader: headerVal,
            dialogData: prompts,
          });
          break;
        default:
          getters.getMaps.forEach((map) => {
            if (
              map.mapName.toLowerCase() ===
              getters.getDefaultLocation.toLowerCase()
            ) {
              dispatch("openImageViewer", {
                name: map.mapName,
                url: map.mapImage,
              });
            }
          });
          //dispatch('avatarSpeak', 'Sorry I’m still learning. Please ask me a different question or, get information about this topic at the Clerk’s Office located here.')
          if (getters.getCurrentLanguage === "en-US") {
            dispatch(
              "avatarSpeak",
              "Sorry, I'm not sure how to answer this question. Please ask me a different question, or you can continue using the touch interface. Also, you can get more information at the location circled in red.",
            );
          } else {
            dispatch(
              "avatarSpeak",
              "Lo siento. No estoy seguro de cómo responder esta pregunta. Por favor, hazme una pregunta diferente, o puedes continuar usando la interfaz táctil. Además, puede obtener más información en la ubicación rodeada de rojo.",
            );
          }
          break;
      }
      // ToDo - Have to complete the intent based answers.
    },
  },
};
